<script lang="ts">
    import { writable } from "svelte/store"
    import { _, number } from "svelte-i18n"
    export let title: string
    export let text: string
    export let url: string
</script>

<button
    on:click="{() => {
        if (navigator.share) {
            navigator.share({
                title: title,
                text: text,
                url: url,
            })
        }
    }}"
    >{$_("mobile.share")}
</button>
